module.exports = __webpack_public_path__ + "img/course2.d56b77f6.png";